export default __webpack_public_path__ + "static/media/deliveries_5.7e15176d.png";